enum DriverContractListingBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export default DriverContractListingBillingModel;
